module.exports = __webpack_public_path__ + "images/light-page-bg.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/light-page-bg.png
// module id = 1067
// module chunks = 17